import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import {
  SiteButtonDefinition,
  SiteButtonProps,
} from '@wix/thunderbolt-components';

export const props = withCompInfo<
  SiteButtonProps,
  SiteButtonDefinition,
  SiteButtonProps
>()([], (_, carmiData) => carmiData);

export default createComponentMapperModel({ props });
